import React, { useState } from 'react'
import { Tab, TabList, Tabs } from '@chakra-ui/react'
import CardPage from 'v2/components/pages/CardPage'
import { Col } from 'v2/components/shared/Col'
import AppContext from 'hooks/helpers/useLastFilter'
import ProcessToCloseReviewTab from './tabs/ProcessToCloseReviewTab'
import AparListingTab from './tabs/AparListingTab'

const ProcessToCloseInternal: React.FC = () => {
  const [tabIndex, setTabIndex] = useState<number>(
    Number(AppContext?.apar_review_tab ?? 0)
  )

  return (
    <CardPage title='Análise Contas a Pagar/Receber (A Fechar)'>
      <Col px={2} w={'100%'}>
        <Tabs
          index={tabIndex}
          onChange={(index) => {
            AppContext.apar_review_tab = index
            setTabIndex(index)
          }}
          colorScheme={'primary'}
          size={'sm'}
          variant={'enclosed'}
        >
          <TabList>
            <Tab>Análise (A Fechar)</Tab>
            <Tab>Contas a Pagar/Receber</Tab>
          </TabList>
        </Tabs>
      </Col>

      {tabIndex === 0 ? <ProcessToCloseReviewTab /> : <AparListingTab />}
    </CardPage>
  )
}

export default ProcessToCloseInternal
